module.exports = __webpack_public_path__ + "img/step-image2.1105b27c.jpg";